import styles from "./hoverEAPhone.scss";
const HoverEAPhone = (props) => {
    let iconClose=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    let hoverStyle=props.hoverText==='text' ? styles.hoverTextStyle:styles.hoverVoiceStyle; 
  return (
    <div className={styles.popUp}>
    <div className={styles.popupContent + ' '+ hoverStyle}>
    <div className={styles.closeIcon}>  <img className={styles.closeIconAlign} 
        src={iconClose} onClick={props.handleClose} alt="close Icon" /></div>
     <div className={styles.contentSpace}>
     {props.preferenceDataPhone && props.preferenceDataPhone.map(phone =>
     <p className={styles.hoverTable}>{phone}</p>
        )
      }
    </div>
    </div> 
    </div>
);};
 
export default HoverEAPhone;